module.exports = __webpack_public_path__ + "static/media/wizualizacja-35.a230e15a.png";